<style lang="scss" scoped>
    $bg: #E0F1F5;
    $border: #9DCAD8;
    $flatblue: #4D8AB7;
    $taBorderRadius: 8px;

    .helpful-hints.arrow-collapse.dropdown{
        background-color: $bg;
        border-radius: $taBorderRadius;
        padding: 1rem 2rem;
        border: none;

        & > .trigger {
            color: $flatblue;
            & .trigger-label {
                vertical-align: middle;
                line-height: 36px;
                float: none;

                .icon-exclaimation {
                    position: relative;
                    top: 7px;
                    display: inline-block;
                    width: 12px;
                    height: 36px;
                    margin-right: 1rem;

                    background: url(~public@/images/ta-resources/exclaimation.png) 0 0 no-repeat;
                }
            }
        }
    }

</style>

<template>
    <arrow-collapse class="helpful-hints w-100" :visible="visible" :showLine="false" :accordion="accordion">
        <template #trigger-label>
            <span class="icon-exclaimation"></span>
            Helpful Hints
        </template>
        <template #collapsed-content>
            <slot></slot>
        </template>
    </arrow-collapse>
</template>

<script>
    import ArrowCollapse from '../ArrowCollapse.vue'

    export default {
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            accordion: {
                type: String,
                default: null
            }
        },
        components: {
            ArrowCollapse
        },
        data() {
            return {}
        },
        methods: {}
    
}
</script>